import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { tDynamic } from "@/i18n/dynamic";
import { fmtDateTime } from "@/i18n/format";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function NotificationBell() {
  const { t } = useI18n();
  const [data, setData] = useState({ unread: 0, items: [] });
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const onOpen = (open) => { if (open && data.unread) api.post("/notifications/read").then(() => setData((d) => ({ ...d, unread: 0 }))); };
  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" aria-label={t("Notifications")} className="relative h-8 w-8 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-colors">
          <Bell className="w-4 h-4" />
          {data.unread > 0 && <span data-testid="notification-unread-count" className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-primary text-[10px] font-bold text-primary-foreground flex items-center justify-center">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notification-panel">
        <div className="px-4 py-3 border-b text-sm font-semibold">{t("Notifications")}</div>
        <div className="max-h-96 overflow-y-auto">
          {!data.items.length && <div className="p-6 text-center text-xs text-muted-foreground" data-testid="notification-empty">{t("You're all caught up.")}</div>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => n.link && navigate(n.link)} data-testid={`notification-${n.id}`}
              className={`w-full text-left px-4 py-3 border-b last:border-0 hover:bg-muted transition-colors ${n.read ? "" : "bg-accent/40"}`}>
              <div className="text-xs font-semibold">{tDynamic(n.title)}</div>
              {n.body && <div className="text-xs text-muted-foreground line-clamp-2 mt-0.5">{n.body}</div>}
              <div className="text-[10px] text-muted-foreground mt-1">{fmtDateTime(n.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
